"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var context_1 = require("../../context");
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        var _a = this.props, leftSide = _a.leftSide, leftSideClassName = _a.leftSideClassName, leftSideStyle = _a.leftSideStyle, rightSide = _a.rightSide, rightSideClassName = _a.rightSideClassName, rightSideStyle = _a.rightSideStyle, style = _a.style, className = _a.className;
        return (React.createElement(context_1.THEME_CONTEXT.Consumer, null, function (theme) {
            var compiledStyles = styles(theme, style, leftSideStyle, rightSideStyle);
            return (React.createElement("div", { className: className, style: compiledStyles.header },
                React.createElement("div", { className: leftSideClassName, style: compiledStyles.leftSide }, leftSide),
                React.createElement("div", { className: rightSideClassName, style: compiledStyles.rightSide }, rightSide)));
        }));
    };
    return Header;
}(React.Component));
var styles = function (theme, style, leftSideStyle, rightSideStyle) { return ({
    header: __assign({ background: theme.common.primaryBoxBackground, padding: theme.header.padding, boxShadow: theme.header.bottomShadow, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }, style),
    leftSide: __assign({}, leftSideStyle),
    rightSide: __assign({}, rightSideStyle),
}); };
exports.default = Radium.default(Header);
